import { PartnerFields } from '../Partner/query';

export const PartnersFields = `
{
    title
    description
    partners ${PartnerFields}
}
`;
